import { useState, useEffect } from "react"

export default function HomePageNavBar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      setIsScrolled(scrollTop > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <>
      <nav className={`fixed w-full top-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-2xl shadow-xl border-b border-gray-200/30' 
          : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo - Desktop & Mobile */}
            <div className="flex items-center h-20">
              <a 
                href="/"
                className="text-green-500 font-bold text-4xl"
              >          
                AW
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-6">
              {/* Desktop Navigation Links */}
              <div className="flex items-center gap-8">
                <a
                  href="#home"
                  className={`text-base font-medium hover:scale-105 transition-all duration-300 relative group ${
                    isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
                  }`}
                >
                  Home
                  <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-green-500 to-emerald-600 group-hover:w-full transition-all duration-300`}></span>
                </a>
                <a
                  href="#mission"
                  className={`text-base font-medium hover:scale-105 transition-all duration-300 relative group ${
                    isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
                  }`}
                >
                  About
                  <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-green-500 to-emerald-600 group-hover:w-full transition-all duration-300`}></span>
                </a>
                <a
                  href="/services"
                  className={`text-base font-medium hover:scale-105 transition-all duration-300 relative group ${
                    isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
                  }`}
                >
                  Services
                  <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-green-500 to-emerald-600 group-hover:w-full transition-all duration-300`}></span>
                </a>
                <a
                  href="#divisions"
                  className={`text-base font-medium hover:scale-105 transition-all duration-300 relative group ${
                    isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
                  }`}
                >
                  Areas of Specialization
                  <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-green-500 to-emerald-600 group-hover:w-full transition-all duration-300`}></span>
                </a>
                <a
                  href="/contact"
                  className={`text-base font-medium hover:scale-105 transition-all duration-300 relative group ${
                    isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
                  }`}
                >
                  Contact
                  <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-green-500 to-emerald-600 group-hover:w-full transition-all duration-300`}></span>
                </a>
              </div>

              {/* Desktop Get Quote Button */}
              <a
                href="/request-quote"
                className={`px-4 py-2 rounded-xl font-semibold text-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 ${
                  isScrolled
                    ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-md hover:shadow-green-500/25'
                    : 'bg-white/10 backdrop-blur-xl text-white hover:bg-white/20 border border-white/30 hover:border-white/50'
                }`}
              >
                Get Quote
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={toggleMobileMenu}
              className={`lg:hidden p-2 rounded-lg transition-all duration-300 ${
                isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={closeMobileMenu}
          ></div>
          <div className="fixed top-16 left-0 right-0 transition-all duration-300 bg-white/30 backdrop-blur-xl shadow-xl border-b border-white/20" style={{ WebkitBackdropFilter: 'blur(16px)', backdropFilter: 'blur(16px)' }}>
            <div className="container mx-auto px-6 py-6">
              <div className="flex flex-col space-y-4">
                {/* Mobile Navigation Links */}
                <a
                  href="#home"
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-3 px-4 rounded-lg transition-all duration-300 ${
                    isScrolled 
                      ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' 
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`}
                >
                  Home
                </a>
                <a
                  href="#mission"
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-3 px-4 rounded-lg transition-all duration-300 ${
                    isScrolled 
                      ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' 
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`}
                >
                  About
                </a>
                <a
                  href="/services"
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-3 px-4 rounded-lg transition-all duration-300 ${
                    isScrolled 
                      ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' 
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`}
                >
                  Services
                </a>
                <a
                  href="#divisions"
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-3 px-4 rounded-lg transition-all duration-300 ${
                    isScrolled 
                      ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' 
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`}
                >
                  Areas of Specialization
                </a>
                <a
                  href="/contact"
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-3 px-4 rounded-lg transition-all duration-300 ${
                    isScrolled 
                      ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' 
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`}
                >
                  Contact
                </a>
                
                {/* Mobile Get Quote Button */}
                <a
                  href="/request-quote"
                  onClick={closeMobileMenu}
                  className="mt-4 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold rounded-xl hover:from-green-600 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105 text-center shadow-lg"
                >
                  Get Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}